import { AUTH_CONST } from '../action/authUIS.action';
import React from 'react';

const initialState = {
        field_token_text: "API токен",
        auth_btn_text: "Войти",
        help_text: "Как получить постоянный ключ API и настроить доступ",
        help_link: "//idea.uiscom.ru/knowledge-bases/2/articles/976-kak-poluchit-postoyannyij-klyuch-api",
        help_target: "_blank",
        input_token_text: "",
        header: "Авторизация",
        user_email: null,
        user_is_auth:  false,
        err_auth_text: "Неправильный токен",
        err_auth_network: "Ошибка: ",
        err_auth_default:"Неправильный токен",
        err_401: ["Ошибка авторизации.", <br></br>, "Не правильный токен."],
        err_403: ["Ошибка авторизации.", <br></br>, "Закрыт доступ к API с IP 195.211.122.131"],
        err_204: "Ошибка: пустой запрос",
        err_400: "Ошибка: не верный формат запроса",
        err_418: "Ошибка: не подключен компонент ",
        err_call_manager: "Обратитесь к персональному менеджеру.",
        is_err: false,
        select_service: '',
        service_list:[
            {name: 'UIS', value: 'uis'},
            {name: 'CoMagic', value: 'comagic'},
            {name: 'CallGear', value: 'callgear'}
        ]
}

export default function reducer(state = initialState, action){
    switch (action.type){
        case AUTH_CONST.SET_INPUT_TOKEN:
            return { ...state, input_token_text: action.payload }
        case AUTH_CONST.SET_STATUS_AUTH:
            return {...state, user_is_auth: action.payload }
        case AUTH_CONST.STATUS_AUTH_WAIT:
            return {...state, auth_btn_text: action.payload?"Авторизация...":"Войти" }
        case AUTH_CONST.ERR_HIDE:
            return {...state, is_err: false}
        case AUTH_CONST.ERR_NETWORK:
            return {...state, is_err: true, err_auth_text: state.err_auth_network + action.payload}
        case AUTH_CONST.ERR_DEFAULT:
            return {...state, is_err: true, err_auth_text: state.err_auth_default}
        case AUTH_CONST.ERR_204:
            return {...state, is_err: true, err_auth_text: state.err_204}
        case AUTH_CONST.ERR_400:
            return {...state, is_err: true, err_auth_text: state.err_400}
        case AUTH_CONST.ERR_401:
            return {...state, is_err: true, err_auth_text: state.err_401}
        case AUTH_CONST.ERR_403:
            return {...state, is_err: true, err_auth_text: state.err_403}
        case AUTH_CONST.ERR_418:
            return {...state}
        case AUTH_CONST.SET_SERVICE:
            return {...state, select_service: action.payload}
    return {...state, is_err: true, err_auth_text: state.err_418 + action.payload + ". " + state.err_call_manager}
        default:
            return state
    }
}